document.addEventListener('DOMContentLoaded', function(e) {
    let form  = document.querySelector('.extended-contact form');

    if (form) {
        let subject = form.querySelector('select#subject');

        if (subject) {
            let sendTo = form.querySelector('input[name="Sent To"]');

            subject.addEventListener('change', () => {
                sendTo.value = subject.options[subject.selectedIndex].dataset.recipient;
            })
        }
    }
})